import { Blog } from "@/components/nyla/Blog";
import { SEO } from "@/components/nyla/SEO";

const journalJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: "https://nylaairwater.earth/" },
      { "@type": "ListItem", position: 2, name: "Journal", item: "https://nylaairwater.earth/journal" },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: "The Nyla Journal",
    url: "https://nylaairwater.earth/journal",
    description:
      "Stories of water, health, and the planet — from the makers of Nyla Air Water.",
    publisher: { "@type": "Organization", name: "Nyla Air Water" },
  },
];

export default function Journal() {
  return (
    <div data-testid="journal-page" className="pt-14">
      <SEO
        title="The Nyla Journal — Stories of Water, Health & the Planet"
        description="Notes on the science of purity, the craft behind every bottle, and the future of sustainable hydration."
        path="/journal"
        keywords="water blog India, sustainable hydration articles, alkaline water science, atmospheric water journal, mineral water stories"
        jsonLd={journalJsonLd}
      />
      <Blog />
    </div>
  );
}
